var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticStyle: {
        display: "flex",
        "justify-content": "center",
        "align-items": "center",
      },
      attrs: { id: "upload-control" },
    },
    [
      _c(
        "el-upload",
        {
          style: {
            width: _vm.computeWidth,
            height: _vm.computeHeight,
            margin: "0 auto",
          },
          attrs: {
            name: "file",
            drag: "",
            "before-upload": _vm.beforeUpload,
            action: _vm.$uploadUrl + _vm.urlUpload,
            "on-success": _vm.handleSuccess,
            "show-file-list": false,
            headers: { token: _vm.token },
            "on-progress": _vm.onProgress,
            "on-error": _vm.onError,
            disabled: _vm.disabled,
          },
        },
        [
          _vm.isProgressing
            ? _c("el-progress", {
                attrs: { type: "circle", percentage: _vm.percentUpload },
              })
            : _vm._e(),
          _vm._v(" "),
          !_vm.isProgressing
            ? [
                _vm.pathImage
                  ? _c("img", {
                      staticClass: "image",
                      staticStyle: {
                        "object-fit": "contain",
                        width: "100%",
                        height: "100%",
                      },
                      attrs: { src: _vm.url(_vm.pathImage), alt: "" },
                    })
                  : [
                      _c("i", { staticClass: "el-icon-upload" }),
                      _vm._v(" "),
                      _c("div", { staticClass: "el-upload__text" }, [
                        _vm._v("\n          Kéo thả vào đây hoặc\n          "),
                        _c("em", [_vm._v("click vào để upload")]),
                      ]),
                    ],
              ]
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }